import { render, staticRenderFns } from "./uni-collapse.vue?vue&type=template&id=4371a8fe"
import script from "./uni-collapse.vue?vue&type=script&lang=js"
export * from "./uni-collapse.vue?vue&type=script&lang=js"
import style0 from "./uni-collapse.vue?vue&type=style&index=0&id=4371a8fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports